import { render } from "./PickDayReport.vue?vue&type=template&id=18093fc2"
import script from "./PickDayReport.vue?vue&type=script&lang=ts"
export * from "./PickDayReport.vue?vue&type=script&lang=ts"
script.render = render

export default script